import { gql } from '@apollo/client'

export const FRAGMENT_FILE_STORAGE_STATISTICS = gql`
  fragment FragmentFileStorageStatistics on FileStorage {
    statistics {
      limitSize
      usedSize
    }
  }
`
